import React, { Component } from "react";
import socketIOClient from "socket.io-client";

const usePuskesmas = (BaseComponent) =>
  class extends Component {
    constructor() {
      super();
      let host = process.env.REACT_APP_URL_ANTRIAN;
      let path = process.env.REACT_APP_URL_ANTRIAN_PATH;

      this.puskesmas = JSON.parse(localStorage.getItem("puskesmasProfile"));
      if (path) {
        this.socket = socketIOClient(
          `${host}/${this.puskesmas.code}`, { path: path }
        );
      } else {
        this.socket = socketIOClient(
          `${host}/${this.puskesmas.code}`
        );
      }
      // console.log( `${host}:8080/${this.puskesmas.code}`)
    }

    componentWillUnmount() {
      this.socket.disconnect();
    }

    render() {
      return (
        <BaseComponent
          {...this.props}
          puskesmas={this.puskesmas}
          socket={this.socket}
        />
      );
    }
  };

export default usePuskesmas;
